import React from 'react';

class Pager extends React.Component {
    constructor(props) {
        super(props);
        this.state = {currentPage: this.props.currentPage, totalPages: this.props.totalPages, searchKey: this.props.searchKey};
    }

    setPage(page){
        this.setState({currentPage: page})
        this.props.fetchUsers(this.state.searchKey, page);
    }

    render() {
        if (!this.state.totalPages || this.state.totalPages <= 1) {
            // don't display pager if there is only 1 page
            return null;
        }

        return (
            <div>
                <ul className="pagination">
                    <li className={this.state.currentPage === 0 ? "disabled" : ""}>
                        <a onClick={() => this.setPage(0)}>First</a>
                    </li>
                    <li className={this.state.currentPage === 0 ? "disabled" : ""}>
                        <a onClick={() => this.setPage(this.state.currentPage - 1)}>Previous</a>
                    </li>
                    <li className={this.state.currentPage + 1 === this.state.totalPages ? "disabled" : ""}>
                        <a onClick={() => this.setPage(this.state.currentPage + 1)}>Next</a>
                    </li>
                    <li className={this.state.currentPage + 1 === this.state.totalPages ? "disabled" : ""}>
                        <a onClick={() => this.setPage(this.state.totalPages - 1)}>Last</a>
                    </li>

                </ul>
                <div>
                    Page {this.state.currentPage + 1 } of {this.state.totalPages}
                </div>
            </div>
        );
    }
}

export default Pager;


// WEBPACK FOOTER //
// ./src/components/pagination/Pager.js